import {palette} from "./class.palette";
import {inputHandler} from "./class.inputhandler";
import {ui} from "./class.ui";
import {gestoreModuli} from "./class.gestoremoduli";

class Anta {
    constructor(scene, assetsManager, parentMesh, tipo, col, row) {
        this._scene = scene;
        this._type = tipo;
        this._multiFaces = [];
        this._currentTexture = new BABYLON.Texture(palette._defaultTexture, this._scene);
        this._mesh = this.generateMappedMesh(this._type, col, row);
        this._mesh._currentColor = palette.hexToRgb('#ffffff');
        this._isSingle = tipo !== 5 && tipo !== 1 && tipo !== 6;

        let materialeAnta = new BABYLON.StandardMaterial("texture1", this._scene);
        materialeAnta.diffuseTexture = this._currentTexture;
        materialeAnta.diffuseColor = palette.rgbToBabylon({r: 255, g: 255, b: 255});
        /*materialeAnta.specularPower = 400; // default 64*/
        materialeAnta.specularColor = new BABYLON.Color3(.2, .2, .2); // default 1, 1, 1
        this._mesh.textureVisible = true;

        this.setMeshPosition();
        this._cornice = this.generateCornice();
        this._mesh.addChild(this._cornice);
        this._mesh.parent = parentMesh;

        this._mesh.position.z += 1.5;
        this._cornice.position = new BABYLON.Vector3(0, 0, -0.05);
        /* this._mesh.position = this._parentMesh.position;
         this._mesh.position.x += 20;*/

        const meshChildren = this._mesh.getChildren();

        if (meshChildren.length <= 1) {
            this._mesh.material = materialeAnta;
        } else {
            for (let i = 0; i < meshChildren.length; i++) {
                meshChildren[i].material = materialeAnta;
            }
        }

        if (this._isSingle) {
            // mouse in
            this._mesh.actionManager = new BABYLON.ActionManager(this._scene);
            /* this._mesh.actionManager.registerAction(
                 new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, m => {
                     if (!inputHandler._isMouseDown) {
                         this.meshOnMouseInEvent(m.meshUnderPointer);
                     }
                 })
             );

             // mouse out
             this._mesh.actionManager.registerAction(
                 new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, m => {
                     this.meshOnMouseOutEvent(m.meshUnderPointer);
                 })
             );*/

            // click
            this._mesh.actionManager.registerAction(
                new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickUpTrigger, m => {
                    if (inputHandler._isClickValid) {
                        const pickResult = this._scene.pick(this._scene.pointerX, this._scene.pointerY);
                        if (pickResult.hit) {
                            this.meshOnMouseClickEvent(pickResult.pickedMesh);
                        }
                    }
                })
            );
        } else {
            this._multiFaces.forEach(mesh => {
                mesh.actionManager = new BABYLON.ActionManager(this._scene);
                /*mesh.actionManager.registerAction(
                    new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, m => {
                        if (!inputHandler._isMouseDown) {
                            this.meshOnMouseInEvent(m.meshUnderPointer);
                        }
                    })
                );

                // mouse out
                mesh.actionManager.registerAction(
                    new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, m => {
                        this.meshOnMouseOutEvent(m.meshUnderPointer);
                    })
                );*/

                // click
                mesh.actionManager.registerAction(
                    new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickUpTrigger, m => {
                        if (inputHandler._isClickValid) {
                            const pickResult = this._scene.pick(this._scene.pointerX, this._scene.pointerY);
                            if (pickResult.hit) {
                                this.meshOnMouseClickEvent(pickResult.pickedMesh);
                            }
                        }
                    })
                );
            })
        }
    }

    meshOnMouseInEvent(mesh) {
        if (this._mesh.textureVisible) {
            // modalità texture attiva, devo mostrare il colore
            mesh.material.diffuseTexture = null;
            mesh.material.diffuseColor = palette.rgbToBabylon(ui._selectedColor);
        } else {
            // modalità colore attiva, devo mostrare la texture
            mesh.material.diffuseTexture = this._currentTexture;
            mesh.material.diffuseColor = new BABYLON.Color3(1, 1, 1)
        }
    }

    meshOnMouseOutEvent(mesh) {
        if (this._mesh.textureVisible) {
            mesh.material.diffuseTexture = this._currentTexture;
            mesh.material.diffuseColor = new BABYLON.Color3(1, 1, 1)
        } else {
            mesh.material.diffuseColor = palette.rgbToBabylon(mesh._currentColor);
            mesh.material.diffuseTexture = null;
        }
    }

    meshOnMouseClickEvent(mesh) {
        if (this._isSingle) {
            if (this._mesh.textureVisible) {
                mesh.material.diffuseColor = palette.rgbToBabylon(ui._selectedColor);
                mesh.material.diffuseTexture = null;
                mesh._currentColor = ui._selectedColor;
            } else {
                mesh.material.diffuseColor = new BABYLON.Color3(1, 1, 1);
                mesh.material.diffuseTexture = this._currentTexture;
            }
        } else {
            this._multiFaces.forEach(subMesh => {
                if (this._mesh.textureVisible) {
                    subMesh.material.diffuseColor = palette.rgbToBabylon(ui._selectedColor);
                    subMesh.material.diffuseTexture = null;
                    subMesh._currentColor = ui._selectedColor;
                } else {
                    subMesh.material.diffuseColor = new BABYLON.Color3(1, 1, 1);
                    subMesh.material.diffuseTexture = this._currentTexture;
                }
            })
        }

        this._mesh.textureVisible = !this._mesh.textureVisible;
    }

    setTexture(textureUrl) {
        this._currentTexture = new BABYLON.Texture(textureUrl, this._scene);
        this._mesh.textureVisible = true;
        if (this._mesh.material !== undefined) {
            this._mesh.material.diffuseColor = new BABYLON.Color3(1, 1, 1);
            this._mesh.material.diffuseTexture = this._currentTexture;
        } else {
            const children = this._mesh.getChildren();
            for (let i = 0; i < children.length; i++) {
                children[i].material.diffuseColor = new BABYLON.Color3(1, 1, 1);
                children[i].material.diffuseTexture = new BABYLON.Texture(this._currentTexture, this._scene);
            }
        }
    }

    destroy() {
        this._mesh.dispose();
        // TODO fare eccezione in caso ci siano più mesh (cassa 180)
    }

    extractData() {
        let json = [];
        for (let i = 0; i < this._meshes.length; i++) {
            json.push({"indice": this._meshes[i].name, "colore": palette.rgbToName(this._meshes[i]._currentColor)});
        }

        return json;
    }

    extractColor() {
        if (this._isSingle) {
            return palette.rgbToName(this._mesh._currentColor);
        } else {
            if (this._multiFaces[1] !== undefined && this._multiFaces[1]._currentColor !== undefined) {
                return palette.rgbToName(this._multiFaces[1]._currentColor);
            }
        }
    }

    hightlightCornice(status, color, currentColorCassa) {
        if (status) {
            this._cornice.getChildren().forEach(subMesh => {
                subMesh.material.diffuseColor = palette.rgbToBabylon(color);
            });
        } else {
            this._cornice.getChildren().forEach(subMesh => {
                subMesh.material.diffuseColor = currentColorCassa;
            });
        }
    }

    generateMappedMesh(tipo, col, row) {
        let c = col; // col
        let r = row; // row
        let columns, rows, bottom, middle, top, left, right, parent;

        columns = 4;  // 6 columns
        rows = 4;  // 4 rows

        const faceUV = new Array(6);

        for (let i = 0; i < 6; i++) {
            faceUV[i] = new BABYLON.Vector4(0, 0, 0, 0);
        }

        faceUV[1] = this.generateUv(columns, rows, c, r);

        switch (tipo) {
            case 1:
                faceUV[1] = this.generateUv(columns, rows, c, r);
                parent = new BABYLON.Mesh("antaParent", this._scene);

                bottom = BABYLON.MeshBuilder.CreateBox('faccia', {
                    width: 60,
                    height: 60,
                    depth: 0.1,
                    faceUV: faceUV
                }, this._scene);

                r++;

                faceUV[1] = this.generateUv(columns, rows, c, r);

                middle = BABYLON.MeshBuilder.CreateBox('faccia', {
                    width: 60,
                    height: 60,
                    depth: 0.1,
                    faceUV: faceUV
                }, this._scene);

                parent.addChild(bottom);
                parent.addChild(middle);

                bottom.position = new BABYLON.Vector3(0, -30, 0);
                middle.position = new BABYLON.Vector3(0, 30, 0);

                this._multiFaces.push(bottom, middle);

                return parent;
            case 5:

                faceUV[1] = this.generateUv(columns, rows, c, r);

                parent = new BABYLON.Mesh("antaParent", this._scene);

                bottom = BABYLON.MeshBuilder.CreateBox('faccia', {
                    width: 60,
                    height: 60,
                    depth: 0.1,
                    faceUV: faceUV
                }, this._scene);

                r++;

                faceUV[1] = this.generateUv(columns, rows, c, r);

                middle = BABYLON.MeshBuilder.CreateBox('faccia', {
                    width: 60,
                    height: 60,
                    depth: 0.1,
                    faceUV: faceUV
                }, this._scene);

                r++;

                faceUV[1] = this.generateUv(columns, rows, c, r);

                top = BABYLON.MeshBuilder.CreateBox('faccia', {
                    width: 60,
                    height: 60,
                    depth: 0.1,
                    faceUV: faceUV
                }, this._scene);

                parent.addChild(bottom);
                parent.addChild(middle);
                parent.addChild(top);

                bottom.position = new BABYLON.Vector3(0, -60, 0);
                middle.position = new BABYLON.Vector3(0, 0, 0);
                top.position = new BABYLON.Vector3(0, 60, 0);

                this._multiFaces.push(bottom, middle, top);

                return parent;
            case 6:

                faceUV[1] = this.generateUv(columns, rows, c, r);

                parent = new BABYLON.Mesh("antaParent", this._scene);

                left = BABYLON.MeshBuilder.CreateBox('faccia', {
                    width: 60,
                    height: 60,
                    depth: 0.1,
                    faceUV: faceUV
                }, this._scene);

                c++;

                faceUV[1] = this.generateUv(columns, rows, c, r);

                right = BABYLON.MeshBuilder.CreateBox('faccia', {
                    width: 60,
                    height: 60,
                    depth: 0.1,
                    faceUV: faceUV
                }, this._scene);

                parent.addChild(left);
                parent.addChild(right);

                left.position = new BABYLON.Vector3(-30, 0, 0);
                right.position = new BABYLON.Vector3(30, 0, 0);

                this._multiFaces.push(left, right);

                return parent;
            default:
                return BABYLON.MeshBuilder.CreateBox('faccia', {
                    width: 60,
                    height: 60,
                    depth: 0.1,
                    faceUV: faceUV
                }, this._scene);
        }
    }

    generateUv(columns, rows, c, r) {
        return new BABYLON.Vector4(c * (1 / columns), r * (1 / rows), (c + 1) * (1 / columns), (r + 1) * (1 / rows));
    }

    generateCornice() {
        const parent = new BABYLON.Mesh("corniceParent", this._scene);
        const materialeAnta = new BABYLON.StandardMaterial("texture1", this._scene);
        materialeAnta.diffuseColor = palette.rgbToBabylon(this._mesh._currentColor);
        this._cornice = parent;
        let top, left, right, bottom;

        switch (this._type) {
            // modulo 60x120
            case 1:
                top = BABYLON.MeshBuilder.CreateBox('cubotto', {
                    width: 60,
                    height: 1,
                    depth: 0.1,
                }, this._scene);

                bottom = BABYLON.MeshBuilder.CreateBox('cubotto', {
                    width: 60,
                    height: 1,
                    depth: 0.1,
                }, this._scene);

                left = BABYLON.MeshBuilder.CreateBox('cubotto', {
                    width: 1,
                    height: 120,
                    depth: 0.1,
                }, this._scene);

                right = BABYLON.MeshBuilder.CreateBox('cubotto', {
                    width: 1,
                    height: 120,
                    depth: 0.1,
                }, this._scene);

                parent.addChild(top);
                parent.addChild(bottom);
                parent.addChild(left);
                parent.addChild(right);

                top.position = new BABYLON.Vector3(0, 59.5, 0);
                bottom.position = new BABYLON.Vector3(0, -59.5, 0);
                left.position = new BABYLON.Vector3(-29.5, 0, 0);
                right.position = new BABYLON.Vector3(29.5, 0, 0);
                break;
            case 5:
                top = BABYLON.MeshBuilder.CreateBox('cubotto', {
                    width: 60,
                    height: 1,
                    depth: 0.1,
                }, this._scene);

                bottom = BABYLON.MeshBuilder.CreateBox('cubotto', {
                    width: 60,
                    height: 1,
                    depth: 0.1,
                }, this._scene);

                left = BABYLON.MeshBuilder.CreateBox('cubotto', {
                    width: 1,
                    height: 180,
                    depth: 0.1,
                }, this._scene);

                right = BABYLON.MeshBuilder.CreateBox('cubotto', {
                    width: 1,
                    height: 180,
                    depth: 0.1,
                }, this._scene);

                parent.addChild(top);
                parent.addChild(bottom);
                parent.addChild(left);
                parent.addChild(right);

                top.position = new BABYLON.Vector3(0, 89.5, 0);
                bottom.position = new BABYLON.Vector3(0, -89.5, 0);
                left.position = new BABYLON.Vector3(-29.5, 0, 0);
                right.position = new BABYLON.Vector3(29.5, 0, 0);
                break;
            // modulo 120x60
            case 6:
                top = BABYLON.MeshBuilder.CreateBox('cubotto', {
                    width: 120,
                    height: 1,
                    depth: 0.1,
                }, this._scene);

                bottom = BABYLON.MeshBuilder.CreateBox('cubotto', {
                    width: 120,
                    height: 1,
                    depth: 0.1,
                }, this._scene);

                left = BABYLON.MeshBuilder.CreateBox('cubotto', {
                    width: 1,
                    height: 60,
                    depth: 0.1,
                }, this._scene);

                right = BABYLON.MeshBuilder.CreateBox('cubotto', {
                    width: 1,
                    height: 60,
                    depth: 0.1,
                }, this._scene);

                parent.addChild(top);
                parent.addChild(bottom);
                parent.addChild(left);
                parent.addChild(right);

                top.position = new BABYLON.Vector3(0, 29.5, 0);
                bottom.position = new BABYLON.Vector3(0, -29.5, 0);
                left.position = new BABYLON.Vector3(-59.5, 0, 0);
                right.position = new BABYLON.Vector3(59.5, 0, 0);
                break;
            // Moduli 60x60
            default:
                top = BABYLON.MeshBuilder.CreateBox('cubotto', {
                    width: 60,
                    height: 1,
                    depth: 0.1,
                }, this._scene);

                bottom = BABYLON.MeshBuilder.CreateBox('cubotto', {
                    width: 60,
                    height: 1,
                    depth: 0.1,
                }, this._scene);

                left = BABYLON.MeshBuilder.CreateBox('cubotto', {
                    width: 1,
                    height: 60,
                    depth: 0.1,
                }, this._scene);

                right = BABYLON.MeshBuilder.CreateBox('cubotto', {
                    width: 1,
                    height: 60,
                    depth: 0.1,
                }, this._scene);

                parent.addChild(top);
                parent.addChild(bottom);
                parent.addChild(left);
                parent.addChild(right);

                top.position = new BABYLON.Vector3(0, 29.5, 0);
                bottom.position = new BABYLON.Vector3(0, -29.5, 0);
                left.position = new BABYLON.Vector3(-29.5, 0, 0);
                right.position = new BABYLON.Vector3(29.5, 0, 0);
                break;
        }

        top.material = bottom.material = left.material = right.material = materialeAnta;

        parent.getChildren().forEach(subMesh => {
            subMesh.actionManager = new BABYLON.ActionManager(this._scene);

            /*subMesh.actionManager.registerAction(
                new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, function (m) {
                    if (!inputHandler._isMouseDown) {
                        gestoreModuli.highlightBody(true);
                    }
                })
            );
            subMesh.actionManager.registerAction(
                new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, function (m) {
                    gestoreModuli.highlightBody(false);
                })
            );*/
            subMesh.actionManager.registerAction(
                new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickUpTrigger, function (m) {
                    if (inputHandler._isClickValid) {
                        gestoreModuli.updateBodyToCurrentColor();
                    }
                })
            );
        });

        return parent;
    }

    setMeshPosition() {
        switch (this._type) {
            case 1:
                this._mesh.position = new BABYLON.Vector3(30, -60, -48);
                break;
            case 5:
                this._mesh.position = new BABYLON.Vector3(30, -90, -48);
                break;
            case 6:
                this._mesh.position = new BABYLON.Vector3(60, -30, -48);
                break;
            default:
                this._mesh.position = new BABYLON.Vector3(30, -30, -48);
                break;
        }
    }
}

export default Anta;
